import React, { useEffect, useState } from 'react';
import { ruleDelete } from '../../../redux/api/ruleAPI';
import Button from '../../ui/button';

import { useTranslation } from 'react-i18next';

const DeleteRuleModal = ({ isOpen, onClose, data }) => {
    const {t} = useTranslation('Rules');
    const [rule, setRule] = useState(data)
    const [error, setError] = useState(null);

    const closeModal = (refresh=false) => {
        onClose(refresh);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Assuming formData contains the user data
            const result = await ruleDelete(rule.Rule_ID); // Call the userAdd function with the form data
            if (result.data)
                closeModal(true); // Close modal or perform other actions
            else
                setError(result.error)
        } catch (error) {
            console.error("Error DEleteting Camera:", error); // Log any errors
            // Handle error (show error message, etc.)
        }
    };
    useEffect(() => {
        setRule(data)
    }, [data])

    return (
        <div className=" grid space-x-6  max-lg:grid-cols-1 grid-cols-2 w-auto m-2 bg-white  max-md:p-3 p-8 rounded-3xl shadow-lg">
            <p className="flex justify-center col-span-2 text-xl  text-[#4C4C66] font-bold mb-10">{t('delete_confirmation')}</p>
            <p className="flex justify-center col-span-2 text-md text-[#4C4C66] font-normal mb-4">{t('are_you_sure_that_you_want_to_delete_this') }<span> &nbsp; </span> <span className='text-[#FF0000] font-bold'>{t('rule')}</span>{t('')}</p>
            <div className='col-span-2 flex justify-center mt-10 space-x-5'>
                <Button type="reset" onClick={closeModal} size="large" color="cancel" >{t('cancel')}</Button>
                <Button
                    type="submit"
                    onClick={handleSubmit}
                    size="large"
                >{t('delete')}</Button>
            </div>
        </div>
    );
};

export default DeleteRuleModal;
